<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Detail Line Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="detailLineList"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="text"
              v-bind:search="search"
              v-model="selected"
              >
              <template v-slot:item="row">
                <tr :active="row.selected" :key="row.item.text">
                  <td class="text-xs-left">{{row.item.text}}</td>
                  <td>
                    <v-checkbox primary hide-details v-model="row.item.subTotal"></v-checkbox>
                  </td>
                  <td>
                    <v-checkbox primary hide-details v-model="row.item.pageBreak"></v-checkbox>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-btn color="error" dark class="mb-2" @click.prevent="doCancel">
              Cancel
              <v-icon dark right>mdi-cancel</v-icon></v-btn>
            <v-btn color="primary" dark class="mb-2" @click="doSelect">
              Select
              <v-icon right>mdi-arrow-right-bold-circle</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
export default {
  data() {
    return {
      search: '',
      headers: [
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      detailLineList: [
        { id: 0, text: 'Agent', value: 'A', subTotal: false, pageBreak: false },
        { id: 1, text: 'Branch', value: 'B', subTotal: false, pageBreak: false },
        { id: 2, text: 'Business Source', value: 'BC', subTotal: false, pageBreak: false },
        { id: 3, text: 'Claim Year', value: 'CY', subTotal: false, pageBreak: false },
        { id: 4, text: 'Class', value: 'C', subTotal: false, pageBreak: false },
        { id: 5, text: 'Class Group', value: 'CG', subTotal: false, pageBreak: false },
        { id: 6, text: 'Client Type', value: 'CT', subTotal: false, pageBreak: false },
        { id: 7, text: 'Country', value: 'CO', subTotal: false, pageBreak: false },
        { id: 8, text: 'Department', value: 'D', subTotal: false, pageBreak: false },
        { id: 9, text: 'Direct / RI', value: 'DR', subTotal: false, pageBreak: false },
        { id: 10, text: 'Executive In Charge', value: 'EC', subTotal: false, pageBreak: false },
        { id: 11, text: 'Fund', value: 'F', subTotal: false, pageBreak: false },
        { id: 12, text: 'Loss Year', value: 'LY', subTotal: false, pageBreak: false },
        { id: 13, text: 'Nature of Loss', value: 'NL', subTotal: false, pageBreak: false },
        { id: 14, text: 'Notification Year', value: 'NY', subTotal: false, pageBreak: false },
        { id: 15, text: 'Policy Type', value: 'PT', subTotal: false, pageBreak: false },
        { id: 16, text: 'Transaction Type', value: 'TY', subTotal: false, pageBreak: false },
        { id: 17, text: 'Underwriting Year', value: 'UY', subTotal: false, pageBreak: false }
      ],
      selected: [
        {
          subTotal: [],
          pageBreak: []
        }
      ],
      errMsg: 'Maximum 3 sort orders can be selected'
    }
  },
  created() {
    this.origArr = clone(this.dl)
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.selectedDetailLineList.length !== 0) {
        this.selectedDetailLineList.map(detailLine => {
          const index = detailLine.id
          this.detailLineList[index] = detailLine
          this.selected.push(detailLine)
        })
      // } else {
      }
    },
    doSelect() {
      const selectedItems = []
      const detailLine = this.detailLineList
      const resultBoth = detailLine.filter(detailLine => detailLine.subTotal === true && detailLine.pageBreak === true)
      const resultSubTotal = detailLine.filter(detailLine => detailLine.subTotal === true && detailLine.pageBreak === false)
      const resultPageBreak = detailLine.filter(detailLine => detailLine.subTotal === false && detailLine.pageBreak === true)
      const bothLength = resultBoth.length * 2 // As if both are selected means it takes 2 slot of the page header
      const stLength = resultSubTotal.length
      const pbLength = resultPageBreak.length
      if (resultBoth.length + stLength + pbLength > 3) {
        this.$toast.error(this.errMsg)
      } else {
        if (bothLength !== 0) {
          for (var iBoth = 0; iBoth < resultBoth.length; iBoth++) {
            selectedItems.push(resultBoth[iBoth])
          }
        }
        if (stLength !== 0) {
          for (var iSt = 0; iSt < stLength; iSt++) {
            selectedItems.push(resultSubTotal[iSt])
          }
        }
        if (pbLength !== 0) {
          for (var iPb = 0; iPb < pbLength; iPb++) {
            selectedItems.push(resultPageBreak[iPb])
          }
        }
        const detailLineObj = {
          detailLine: selectedItems,
          from: 'detailLine'
        }
        this.$emit('doAssign', detailLineObj)
        this.$emit('close')
      }
    },
    doCancel() {
      const detailLineObj = {
        detailLine: this.origArr,
        from: 'detailLine'
      }
      this.$emit('doAssign', detailLineObj)
      this.$emit('close')
    }
  },
  computed: {
    selectedDetailLineList() {
      return this.dl
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  props: {
    'dl': Array
  }
}
</script>
